import { PartnerDocumentUpdateRequest } from 'src/api/PartnerDocumentUpdateRequest';
import { PartnerDocumentsListResponse } from 'src/api/PartnerDocumentsListResponse';
import { StoreResponse } from 'src/api/StoreResponse';
import apiClient from './core/ApiClient';

const root = '/api/partners/documents';

export interface PartnerDocumentListFilters {
    partnerId?: number;
    projectId?: number;
}

const queryParams = (filters?: PartnerDocumentListFilters): string => {
    const params = new URLSearchParams();
    if (filters?.partnerId) {
        params.append('partner_id', filters.partnerId.toString());
    }
    if (filters?.projectId) {
        params.append('project_id', filters.projectId.toString());
    }
    return params.toString();
};

const listAll = (filters?: PartnerDocumentListFilters): Promise<PartnerDocumentsListResponse> => {
    const query = queryParams(filters);
    return apiClient.get<PartnerDocumentsListResponse>(query ? `${root}?${query}` : root);
};

const upload = (file: File, projectId: number, comments?: string | null): Promise<StoreResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', String(projectId));
    if (comments?.trim()) {
        formData.append('comments', comments.trim());
    }

    return apiClient.upload<StoreResponse>(`${root}/upload`, formData).then(r => r.data);
};

const update = (id: number, projectId: number, comments?: string | null): Promise<void> => {
    const payload: PartnerDocumentUpdateRequest = {
        projectId,
        comments: comments?.trim() ? comments.trim() : null,
    };

    return apiClient.put<PartnerDocumentUpdateRequest, void>(`${root}/${id}`, payload);
};

const remove = (id: number): Promise<void> => apiClient.delete<void>(`${root}/${id}`);

const download = (id: number): Promise<Blob> => apiClient.download(`${root}/${id}/download`);

export const partnerDocumentService = {
    listAll,
    queryParams,
    upload,
    update,
    remove,
    download,
};
